import useAutoCenter from './hooks/internal/useAutoCenter';

const AutoCenter = () => {
  useAutoCenter();

  return false;
};

export default AutoCenter;
